export default {
  data() {
    return {
      errors: null,
      formData: {},
      settings: [],
      categories: [],
      savedSettings: [],
      processingSave: false,
      initialLoading: true,
      allSettings: [],
    };
  },

  async beforeMount() {
    await this.prepareData();
  },

  methods: {
    handleError(error) {
      this.errors = _.uniq(_.flatMap(error.errors));

      Swal.fire({
        text: error.message,
        icon: 'error',
        showConfirmButton: false,
        timer: 2000,
      });
    },

    getSettingsData(categoryName) {
      return this.settings[categoryName];
    },

    getSavedSettingsValue(settingId) {
      const setting = _.find(this.savedSettings, { setting_id: settingId });

      let settingData = null;
      settingData = _.find(this.allSettings, { id: settingId });

      if (setting && setting.value == null) {
        return settingData.default_value;
      }

      return setting ? setting.value : settingData.default_value;
    },

    async prepareData() {
      await axios.get(this.prepareDataEndpoint).then(({ data }) => {
        this.settings = data.data.settings;
        this.categories = data.data.categories;
        this.savedSettings = data.data.savedSettings;

        Object.keys(this.settings).forEach(categorySetting => {
          Object.keys(this.settings[categorySetting]).forEach(groupSetting => {
            this.settings[categorySetting][groupSetting].forEach(setting => {
              this.allSettings.push(setting);

              this.formData[setting.id] = {};
              this.formData[setting.id].setting_id = setting.id;
              this.formData[setting.id].value = this.getSavedSettingsValue(setting.id);
              if (setting.format_date !== null) {
                this.formData[setting.id].format_date = setting.format_date;
              }

              this.prepareSettingDependency(setting);
            });
          });
        });
      });

      this.initialLoading = false;
    },

    async saveSettings() {
      this.processingSave = true;
      await axios
        .patch(this.saveSettingsEndpoint, {
          settings: this.formData,
        })
        .then(() => {
          this.errors = null;
          Swal.fire({
            text: this.trans('dashboard.alerts.success_save_settings'),
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
          });
        })
        .catch(({ response }) => {
          this.handleError(response.data);
        });

      this.processingSave = false;
    },

    handleInputDependency(event) {
      this.formData[event.dependencyId].value = event.value;
    },

    prepareSettingDependency(setting) {
      if (Array.isArray(setting.dependency_settings) && setting.dependency_settings.length > 0) {
        const dependencies = setting.dependency_settings;

        for (const dependenciesKey in dependencies) {
          const dependency = dependencies[dependenciesKey];

          if (Array.isArray(dependency.dependency_settings) && dependency.dependency_settings.length > 0) {
            this.prepareSettingDependency(dependency);
          }
          this.allSettings.push(dependency);
          this.formData[dependency.id] = {};
          this.formData[dependency.id].setting_id = dependency.id;
          this.formData[dependency.id].value = this.getSavedSettingsValue(dependency.id);
          if (dependency.format_date !== null) {
            this.formData[dependency.id].format_date = dependency.format_date;
          }
        }
      }
    },
  },
};
